import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';

// Constants
import KM_TYPE from 'constants/kmType';

// Actions
import { changeKmType } from 'store/ducks/trips/actions';

// Types
import { ApplicationState } from 'store';

// Styles
import useStyles from './kmTypeFilter.styles';

const KmTypeFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const kmType = useSelector((state: ApplicationState) => state.trips.kmType);

  return (
    <List dense>
      {KM_TYPE.TYPES.map(({ KEY, VALUE }) => (
        <ListItem key={KEY} button>
          <ListItemText
            id={KEY}
            primary={VALUE}
            onClick={() => {
              dispatch(
                changeKmType({
                  kmType: KEY,
                }),
              );
            }}
          />
          <ListItemSecondaryAction>
            <Radio
              edge='end'
              color='primary'
              onChange={() => {
                dispatch(
                  changeKmType({
                    kmType: KEY,
                  }),
                );
              }}
              checked={kmType === KEY}
              inputProps={{ 'aria-labelledby': VALUE }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export default KmTypeFilter;
export { KmTypeFilter };
